import axios from 'axios';

const path = '/addons/vbzws';

export default {
  loadModuleData() {
    return axios.get(`/modules/vbzworksheet/`);
  },
  fetchDutyActivities(dutyId) {
    console.debug('fetchDutyActivities', `/modules/vbzworksheet/dutyActivities/${dutyId}`);
    return axios.get(`/modules/vbzworksheet/dutyActivities/${dutyId}`);
  },
  fetchDaysWithDuties() {
    return axios.get(`/modules/vbzworksheet/duties/days`);
  },
  fetchDutyActivitiesByCompanyNrAndDay(companyNr, dayIsoString) {
    return axios.get(`/modules/vbzworksheet/duties/by-companynr-and-day/${companyNr}/${dayIsoString}`);
  },
  fetchDutiesByDay(dayIsoString) {
    return axios.get(`/modules/vbzworksheet/duties/${dayIsoString}`);
  },
  fetchDutiesByCompanyNr(employeenr) {
    return axios.get(`/modules/vbzworksheet/duties/by-companynr/${employeenr}`);
  },
  fetchEmployeeNrsWithDuties() {
    return axios.get(`/modules/vbzworksheet/employeers-with-duties`);
  },

  loadUserData() {
    return axios.get(`users-not-deleted`);
  },
  findUserByCompanyNr(companyNr) {
    return axios.get(`users/search`, { params: { companyNr } });
  },
  // TODO: Add all REST calls here
  fetchAll(domain) {
    return axios.get(`${path}/${domain}`);
  },
  fetchWhere(domain, where) {
    return axios.get(`${path}/${domain}`, { params: where });
  },
  create(domain, domainObject) {
    return axios.post(`${path}/${domain}`, domainObject);
  },
  update(domain, domainObject) {
    return axios.put(`${path}/${domain}`, domainObject);
  },
  delete(domain, domainObject) {
    return axios.delete(`${path}/${domain}`, { data: domainObject });
  },
};
